import {CSS_ARMOR_CLASS, CSS_CLASS_PREFIX} from "../constants/css";

const cssMainSelector = (tdsId, options = {}) => {
  // This creates specificity for css "#id#id#id#id", the number of times we
  // need it is just trial and error with the app in the wild.
  let mainSelector = `.${CSS_ARMOR_CLASS}`;

  // options
  const ampCount = options["ampCount"] || 2;
  const mediaSizeName = options["mediaSizeName"] || null;
  const selectorCount = options["selectorCount"] || 6;

  for (let counter = 0; counter < selectorCount; counter++) {
    mainSelector = `#${tdsId}${mainSelector}`
  }

  let amps = "";
  for (let counter = 0; counter < ampCount; counter++) {
    amps= `${amps}&`
  }

  let mediaClassNameStr = "";
  if (mediaSizeName != null) {
    mediaClassNameStr = ` ${mediaClassName(mediaSizeName)}`;
  }

  return `${mainSelector}${mediaClassNameStr} ${amps}`;
};

const mediaClassName = sizeName => {
  return `.${CSS_CLASS_PREFIX}-${sizeName}`;
};

export { cssMainSelector, mediaClassName };
